import { render, staticRenderFns } from "./oil.table.vue?vue&type=template&id=77fb7230&scoped=true&"
import script from "./oil.table.vue?vue&type=script&lang=js&"
export * from "./oil.table.vue?vue&type=script&lang=js&"
import style0 from "./oil.table.vue?vue&type=style&index=0&id=77fb7230&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb7230",
  null
  
)

export default component.exports